import { render } from "./UseRegister.vue?vue&type=template&id=6af1eabc"
import script from "./UseRegister.vue?vue&type=script&lang=js"
export * from "./UseRegister.vue?vue&type=script&lang=js"

import "./UseRegister.vue?vue&type=style&index=0&id=6af1eabc&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__